(function () {
  'use strict';
  if (window.famousProductReferencesReady) return;
  window.famousProductReferencesReady = true;
  function reveal(hash, updateHistory) {
    if (!/^#fp-source-\d+$/.test(hash)) return false;
    var target = document.getElementById(hash.slice(1));
    var body = document.querySelector('[data-drehmer-about-body]');
    var container = body && body.closest('[data-drehmer-about]');
    if (!target || !body || !container || !body.contains(target)) return false;
    container.classList.add('is-expanded');
    body.scrollTop = 0;
    var button = container.querySelector('[data-drehmer-about-toggle]');
    if (button) {
      button.setAttribute('aria-expanded', 'true');
      var label = button.querySelector('[data-drehmer-about-text]');
      if (label) label.textContent = 'Show less';
    }
    if (updateHistory && location.hash !== hash) history.pushState(null, '', hash);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        target.setAttribute('tabindex', '-1');
        target.focus({preventScroll: true});
        target.scrollIntoView({block: 'center', behavior: 'instant'});
      });
    });
    return true;
  }
  document.addEventListener('click', function (event) {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var link = event.target.closest('a[href^="#fp-source-"]');
    if (link && reveal(link.getAttribute('href'), true)) event.preventDefault();
  });
  window.addEventListener('hashchange', function () { reveal(location.hash, false); });
  if (document.readyState === 'complete') reveal(location.hash, false);
  else window.addEventListener('load', function () { reveal(location.hash, false); }, {once: true});
}());
